import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Buffer } from 'buffer';
import './styles/globals.css';
import { injectResponsiveStyles } from './hooks/useResponsive.js';
import App from './App.jsx';

// Polyfill Node's Buffer for the browser. @react-pdf/renderer / pdfkit needs
// it to decode image bytes when generating PDFs.
if (typeof window !== 'undefined' && !window.Buffer) {
  window.Buffer = Buffer;
}

injectResponsiveStyles();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);
